module.exports = __webpack_public_path__ + "img/al-nisr.ab1ade0b.png";